import SendMessage from '../icons/SendMessage'
import React, { useState } from 'react'

const ChatInput = ({ sendMessage }: { sendMessage: (message: string) => void }) => {
  const [message, setMessage] = useState('')

  const handleSendMessage = () => {
    sendMessage(message)
    setMessage('')
  }

  const onKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSendMessage()
    }
  }

  return (
    <div className="bg-white">
      <div className="h-4" />
      <div className="flex justify-between items-center">
        <input
          value={message}
          onKeyDown={onKeyPress}
          onChange={(e) => {
            setMessage(e.target.value)
          }}
          className="border-none outline-none text-14 px-2 flex-1 text-slateGray"
          placeholder="Aa"
        />
        <div onClick={handleSendMessage} className="w-8 h-6 mr-2 text-slateGray cursor-pointer">
          <SendMessage />
        </div>
      </div>
      <div className="h-1" />
      <div className="h-4 border-t border-slateGray" />
      <div className="h-4" />
    </div>
  )
}

export default ChatInput
